import {
  createStyles,
  SimpleGrid,
  Card,
  Image,
  Text,
  Container,
  AspectRatio,
  Title,
  Box,
  Group,
  Avatar,
  Button,
  rem,
  Center,
  ActionIcon
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import Anja from '../../assets/team/Anja_profile.jpeg';
import Jente from '../../assets/team/Jente_profile.jpg';
import Kasia from '../../assets/team/Kasia_profile.jpg';
import Jacob from '../../assets/team/Jacob_profile.jpeg';
import { IconRun, IconBallTennis, IconCooker, IconDog, IconGoGame, IconMountain, IconYoga, IconPaint, IconMusic, IconBook, IconCode, IconExternalLink, IconBrandLinkedin, IconToolsKitchen, IconPencil, IconDeviceGamepad } from '@tabler/icons-react';

const useStyles = createStyles((theme) => ({
  card: {
    transition: 'transform 150ms ease, box-shadow 150ms ease',
    '&:hover': {
      transform: 'scale(1.01)',
      boxShadow: theme.shadows.md,
    },
    backgroundColor: '#F9FAFB',
    padding: 0,
    overflow: 'hidden',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: 560,
    margin: 'auto',
  },

  sectionLabel: {
    fontSize: rem(16),
    color: theme.colors.resirent[0],
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: rem(8),
    marginTop: rem(60),
  },

  headerTitle: {
    fontSize: rem(48),
    fontWeight: 560,
    textAlign: 'center',
    marginBottom: rem(24),
    maxWidth: 1100,
    marginLeft: 'auto',
    marginRight: 'auto',
    ["@media (max-width: 768px)"]: {
      fontSize: rem(32),
    },
  },

  subText: {
    fontSize: rem(18),
    color: '#667085',
    fontWeight: 400,
    textAlign: 'center',
    margin: '0 auto',
    maxWidth: 640,
    ["@media (max-width: 768px)"]: {
      fontSize: rem(14),
    },
  },

  title: {
    fontWeight: 600,
  },

  control: {
    '&:hover': {
      color: theme.white,
      backgroundColor: theme.colors.resirentPink?.[5] || '#FF5A5F',
    },
    border: `2px solid ${theme.colors.resirentPink?.[8] || '#FF5A5F'}`,
    backgroundColor: theme.white,
    color: theme.colors.resirentPink?.[5] || '#FF5A5F',
    textAlign: 'center',
  },
}));

export default function Team() {
  const { classes } = useStyles();
  const languagePrefix = window.location.pathname.startsWith('/nl') ? '/nl' : window.location.pathname.startsWith('/de') ? '/de' : '/';
  const isMobile = useMediaQuery('(max-width: 768px)');

  const teamEN = [
    {
      id: 1,
      name: 'Anja Bulteel',
      role: 'Founder and Content Lead',
      imageUrl: Anja,
      description: "Anja wears many hats at ResiRent. From providing the team with insights based on her experience as a small host to crafting engaging content for the platform, she plays a pivotal role in shaping ResiRent's identity. Anja also establishes and nurtures partnerships with local businesses and tourism offices to enhance the offerings for hosts.",
      href: 'https://www.linkedin.com/in/anja-bulteel-05979aa4/?originalSubdomain=ch',
      icons: [IconDog, IconToolsKitchen, IconMountain],
    },
    {
      id: 2,
      name: 'Jente Clarysse',
      role: 'Software engineer, Creative Director',
      imageUrl: Jente,
      description: "Jente leads the creative team, overseeing the design and branding aspects of ResiRent. She collaborates closely with our tech experts to ensure a seamless fusion of technology and design in our solutions.",
      href: 'https://www.linkedin.com/in/jente-clarysse',
      icons: [IconRun, IconPencil, IconDog, IconMountain, IconCode],
    },
    // {
    //   id: 3,
    //   name: 'Kasia Krasnopolska',
    //   role: 'Software engineer ',
    //   imageUrl: Kasia,
    //   description: "Kasia is a key player in our tech team, responsible for developing and maintaining the software architecture that powers ResiRent's digital solutions. From implementing new features to optimizing performance, Kasia ensures our platforms are robust and user-friendly.",
    //   href: 'https://www.linkedin.com/in/anja-bulteel-05979aa4/?originalSubdomain=ch',
    //   icons: [IconYoga, IconMountain, IconMusic, IconDeviceGamepad, IconCode],
    // },
    {
      id: 4,
      name: 'Jacob Clarysse',
      role: 'Software engineer ',
      imageUrl: Jacob,
      description: "As a key architect in our tech team, Jacob shapes and refines the backend infrastructure that propels ResiRent's digital solutions. From optimizing data processes to introducing cutting-edge features, Jacob ensures our platforms deliver a seamless experience.",
      href: 'https://www.linkedin.com/in/jacob-clarysse',
      icons: [IconBallTennis, IconBook, IconMountain, IconCode],
    },
  ];

  const teamNL = [
    {
      id: 1,
      name: 'Anja Bulteel',
      role: 'Oprichter en Content Lead',
      imageUrl: Anja,
      description: "Anja draagt bij ResiRent veel verschillende petten. Van het delen van inzichten met het team op basis van haar ervaring als kleine host tot het creëren van boeiende content voor het platform, speelt ze een cruciale rol in het vormgeven van de identiteit van ResiRent. Anja legt ook contacten en onderhoudt samenwerkingen met lokale bedrijven en toerismekantoren om het aanbod voor hosts te verbeteren.",
      href: 'https://www.linkedin.com/in/anja-bulteel-05979aa4/?originalSubdomain=ch',
      icons: [IconDog, IconToolsKitchen, IconMountain],
    },
    {
      id: 2,
      name: 'Jente Clarysse',
      role: 'Software engineer, Creatief Directeur',
      imageUrl: Jente,
      description: "Jente leidt het creatieve team en houdt toezicht op het ontwerp en de branding van ResiRent. Ze werkt nauw samen met onze tech-experts om een naadloze fusie van technologie en design in onze oplossingen te garanderen.",
      href: 'https://www.linkedin.com/in/jente-clarysse',
      icons: [IconRun, IconPencil, IconDog, IconMountain, IconCode],
    },
    // {
    //   id: 3,
    //   name: 'Kasia Krasnopolska',
    //   role: 'Software engineer',
    //   imageUrl: Kasia,
    //   description: "Kasia is een sleutelfiguur in ons techteam, verantwoordelijk voor de ontwikkeling en het onderhoud van de softwarearchitectuur die de digitale oplossingen van ResiRent aandrijft.",
    //   href: 'https://www.linkedin.com/in/anja-bulteel-05979aa4/?originalSubdomain=ch',
    //   icons: [IconYoga, IconMountain, IconMusic, IconDeviceGamepad, IconCode],
    // },
    {
      id: 4,
      name: 'Jacob Clarysse',
      role: 'Software engineer',
      imageUrl: Jacob,
      description: "Als een belangrijke architect in ons techteam vormt Jacob de backend-infrastructuur die de digitale oplossingen van ResiRent aandrijft.",
      href: 'https://www.linkedin.com/in/jacob-clarysse',
      icons: [IconBallTennis, IconBook, IconMountain, IconCode],
    },
  ];

  const teamDE = [
    {
      id: 1,
      name: 'Anja Bulteel',
      role: 'Gründerin und Leiterin für Inhalte',
      imageUrl: Anja,
      description: "Anja trägt bei ResiRent viele verschiedene Hüte. Vom Teilen von Erkenntnissen mit dem Team aufgrund ihrer Erfahrung als kleine Gastgeberin bis hin zur Erstellung von ansprechenden Inhalten für die Plattform spielt sie eine entscheidende Rolle bei der Gestaltung der Identität von ResiRent. Anja knüpft außerdem Kontakte und pflegt Partnerschaften mit lokalen Unternehmen und Tourismusbüros, um das Angebot für Gastgeber zu verbessern.",
      href: 'https://www.linkedin.com/in/anja-bulteel-05979aa4/?originalSubdomain=ch',
      icons: [IconDog, IconToolsKitchen, IconMountain],
    },
    {
      id: 2,
      name: 'Jente Clarysse',
      role: 'Softwareentwicklerin, Kreativdirektorin',
      imageUrl: Jente,
      description: "Jente leitet das Kreativteam und überwacht die Design- und Branding-Aspekte von ResiRent. Sie arbeitet eng mit unseren Technikexperten zusammen, um eine nahtlose Fusion von Technologie und Design in unseren Lösungen zu gewährleisten.",
      href: 'https://www.linkedin.com/in/jente-clarysse',
      icons: [IconRun, IconPencil, IconDog, IconMountain, IconCode],
    },
    // {
    //   id: 3,
    //   name: 'Kasia Krasnopolska',
    //   role: 'Softwareentwicklerin',
    //   imageUrl: Kasia,
    //   description: "Kasia ist eine Schlüsselfigur in unserem Technikteam, verantwortlich für die Entwicklung und Wartung der Softwarearchitektur, die die digitalen Lösungen von ResiRent antreibt.",
    //   href: 'https://www.linkedin.com/in/anja-bulteel-05979aa4/?originalSubdomain=ch',
    //   icons: [IconYoga, IconMountain, IconMusic, IconDeviceGamepad, IconCode],
    // },
    {
      id: 4,
      name: 'Jacob Clarysse',
      role: 'Softwareentwickler',
      imageUrl: Jacob,
      description: "Als wichtiger Architekt in unserem Technikteam gestaltet Jacob die Backend-Infrastruktur, die die digitalen Lösungen von ResiRent antreibt.",
      href: 'https://www.linkedin.com/in/jacob-clarysse',
      icons: [IconBallTennis, IconBook, IconMountain, IconCode],
    },
  ];

  const team = window.location.pathname.startsWith('/nl') ? teamNL : window.location.pathname.startsWith('/de') ? teamDE : teamEN;

  const content = {
    '/': {
      'pageTitle': 'The team',
      'groupTitle': 'Meet the Team Behind ResiRent',
      'description': 'ResiRent, founded in 2023, helps small hosts thrive with smart technology and expert support. Our diverse team simplifies hosting through innovation.',
    },
    '/nl': {
      'pageTitle': 'Het Team',
      'groupTitle': 'Ontmoet het Team Achter ResiRent',
      'description': 'ResiRent, opgericht in 2023, helpt kleine verhuurders te floreren met slimme technologie en deskundige ondersteuning. Ons diverse team vereenvoudigt het verhuren door middel van innovatie.',
    },
    '/de': {
      'pageTitle': 'Das Team',
      'groupTitle': 'Lernen Sie das Team Hinter ResiRent kennen',
      'description': 'ResiRent, gegründet im Jahr 2023, hilft kleinen Gastgebern, mit intelligenter Technologie und kompetenter Unterstützung erfolgreich zu sein. Unser vielfältiges Team vereinfacht die Vermietung durch Innovation.',
    },
  };
  
  
  return (
    <Container mt={40} mb={20}>
      <Text className={classes.sectionLabel}>{content[languagePrefix].pageTitle}</Text>
      <Title className={classes.headerTitle}>{content[languagePrefix].groupTitle}</Title>
      <Text className={classes.subText}>{content[languagePrefix].description}</Text>

      <SimpleGrid cols={2} breakpoints={[{ maxWidth: 768, cols: 1 }]} spacing="xl" mt={50}>
        {team.map((member, index) => {
          const isLast = index === team.length - 1;
          const isOdd = team.length % 2 !== 0;
          if (isLast && isOdd && !isMobile) {
            return (
              <Box key={member.id} style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'center', maxWidth: '100%' }}>
                <TeamCard member={member} classes={classes} />
              </Box>
            );
          }
          return <TeamCard key={member.id} member={member} classes={classes} />;
        })}
      </SimpleGrid>
    </Container>
  );
}

const TeamCard = ({ member, classes }) => (
  <Card shadow="sm" className={classes.card}>
    <Box style={{ width: '100%', height: 400, overflow: 'hidden' }}>
      <Image src={member.imageUrl} alt={member.name} width="100%" height={400} fit="cover" />
    </Box>
    <Box p="xl" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
    <Group position="apart" spacing={4} mt={6} mb={0}>
        <Title order={3} className={classes.title}>{member.name}</Title>
        <ActionIcon className={classes.control} component="a" href={member.href} variant="outline" color="resirentPink" size="lg">
          <IconBrandLinkedin size={22} />
        </ActionIcon>
      </Group>
      <Text size="md" color="#003D51" mt={2} style={{ fontWeight: 500 }}>{member.role}</Text>
      <Text size="md" mt={12} mb={12} style={{ color: '#667085' }}>{member.description}</Text>
      <Group spacing="xs" mt="auto">
        {member.icons.map((Icon, idx) => (
          <Icon key={idx} size={22} />
        ))}
      </Group>
    </Box>
  </Card>
);
